module.exports = __webpack_public_path__ + "images/syuccho_kaitori_lp/cases/q2_23136b0260dcd9535c0f13f54ca48769.png";